module.exports = __webpack_public_path__ + "img/search.fc18d49f.svg";